var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$root.user !== false && _vm.$root.is_member > 0 && _vm.show
      ? _c("div", { staticClass: "c-comments__insert" }, [
          _c("img", {
            staticClass: "c-comments__img",
            attrs: { src: _vm.$root.user.avatar, alt: "Commenting User" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-comments__box" },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment",
                  },
                ],
                class: [
                  "c-comments__input",
                  _vm.showActions ? "activeTextarea" : "",
                ],
                attrs: { placeholder: _vm.placeholder, rows: "1" },
                domProps: { value: _vm.comment },
                on: {
                  keyup: _vm.autosize,
                  paste: _vm.autosize,
                  click: _vm.showActionsBar,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.comment = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.commentImage
                ? _c("div", { staticClass: "comment-photo-uploaded" }, [
                    _c("img", { attrs: { src: _vm.commentImage, alt: "" } }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("file-upload", {
                ref: "commentupload-" + _vm.uuid,
                attrs: {
                  extensions: "gif,jpg,jpeg,png,webp",
                  accept: "image/png,image/gif,image/jpeg,image/webp",
                  "post-action": "/post/comment-upload",
                  data: _vm.commentData,
                  name: "commentupload-" + _vm.uuid,
                },
                on: {
                  "input-filter": _vm.uploadInputFilter,
                  "input-file": _vm.uploadInputFile,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "c-comments__bar",
                    _vm.showActions ? "activeUpload" : "",
                  ],
                  attrs: { id: "bar" },
                },
                [
                  _c("label", { attrs: { for: "commentupload-" + _vm.uuid } }, [
                    _c("img", {
                      attrs: {
                        src: _vm.$cdn("/img/ui/icon-upload.svg"),
                        alt: "Upload",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.progressData
                    ? _c("div", { staticClass: "comment-image-progress" }, [
                        _vm._v(_vm._s(_vm.progressData)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "c-btn c-btn--blue",
                      attrs: {
                        id: "saveComment",
                        type: "button",
                        disabled: _vm.saveDisabled,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.save.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.$cdn("/img/ui/icon-post.svg"),
                          alt: "Post",
                          height: "17",
                          width: "17",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Post")]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm.$root.user !== false && _vm.show
      ? _c("div", { staticClass: "c-comments__insert" }, [
          _c("img", {
            staticClass: "c-comments__img",
            attrs: { src: _vm.$root.user.avatar, alt: "Commenting User" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "c-comments__box",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.triggerJoinCommunity.apply(null, arguments)
                },
              },
            },
            [
              _c("textarea", {
                staticClass: "c-comments__input",
                attrs: {
                  id: "comment",
                  placeholder: _vm.placeholder,
                  rows: "1",
                  disabled: "",
                },
              }),
            ]
          ),
        ])
      : _vm.show
      ? _c(
          "div",
          {
            staticClass: "c-comments__insert",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.showMemberPanel.apply(null, arguments)
              },
            },
          },
          [
            _c("img", {
              staticClass: "c-comments__img",
              attrs: {
                src: _vm.$cdn("/img/avatar-default.svg"),
                alt: "Commenting User",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "c-comments__box" }, [
              _c("textarea", {
                class: ["c-comments__input", "disabled"],
                attrs: {
                  id: "comment",
                  placeholder: _vm.placeholder,
                  rows: "1",
                  disabled: "",
                },
              }),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }